<template>

    <div class="">

        <button v-if="isOpen" class="flex-none fixed bg-theme-dropdowndismissal opacity-75 cursor-default w-full h-full"
                style="top: 64px; left: 0;" @click="isOpen = false"></button>

        <i class="material-icons text-theme-headertext md:mr-4 cursor-pointer md:invisible md:w-0" style="font-size: 30px;" @click="showSearch">search</i>

        <button v-if="notLoggedIn" @click="goLogin">
            <i class="material-icons text-theme-headertext cursor-pointer" style="font-size: 30px;">login</i>
            <!--<i class="material-icons ml-1 mr-1 pt-2 cursor-pointer w-10 h-10 icon-circled-dark text-theme-main">login</i>-->
        </button>

        <button v-else @click="isOpen = !isOpen">
<!--            <i class="material-icons text-theme-headertext cursor-pointer" style="font-size: 30px;">account_circle</i>-->
            <img :src="userAvatar" alt="Avatar" width="30" height="30">
        </button>

        <div v-if="isOpen" class="rounded-lg py-2 shadow-lg bg-theme-level4 w-48 absolute" style="right: 12px;">
            <button class="dropdownItem hover:bg-theme-menuhoverbg hover:text-theme-menuhovertext"
                    v-on:click="gotoProfile">{{ translate('my-profile') }}</button>
            <button class="dropdownItem hover:bg-theme-menuhoverbg hover:text-theme-menuhovertext"
                    v-on:click="logout">{{ translate('logout') }}</button>
        </div>

    </div>

</template>

<script>

    const Lang = require('lang.js');
    import translations from './messages.js';

    const lang = new Lang();

    lang.setMessages(translations);

    export default {

        data() {
            return {
                isOpen: false,
                notLoggedIn: !(window.Laravel.user)
            }
        },

        props: [
            'currentlocale'
        ],

        computed: {

            userAvatar() {

                return window.Laravel.userAvatar

            }

        },

        methods: {

            translate(key) {
                key = 'strings.' + key;
                return lang.get(key);
            },

            goLogin() {
                window.location='/' + this.currentlocale +  '/login';
            },

            showSearch() {
                Event.fire('showMobileSearch');
            },

            gotoProfile() {
                window.location='/' + this.currentlocale + '/profile';
            }

        },

        mounted() {
            console.log('DropDown component mounted.')
        }
    }
</script>
